import { Component, OnInit } from '@angular/core';

import { AuthentificationService } from '../../services/authentification.service';
import { ModalsService, ConfirmableActions } from '../../services/modals.service';



@Component({
  selector: 'app-head',
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.scss']
})
export class HeadComponent implements OnInit {
  private isMenuOpened = false;

  constructor(
    private auth: AuthentificationService,
    private modals: ModalsService,
  ) { }

  ngOnInit() {
  }

  logout() {
    this.modals.openWarning(
      'Logut',
      'Are you sure that you want to logout?',
      ConfirmableActions.Logout
    ).then((isAgreed: boolean) => {
      if (isAgreed) {
        this.auth.logout();
      }
    });
  }

  toggleMenu() {
    this.isMenuOpened = !this.isMenuOpened;
  }
}



// WEBPACK FOOTER //
// ./src/app/header/head/head.component.ts